export default __webpack_public_path__ + "static/media/hbs-blk-banner-2.d65c078d.jpg";